import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import * as moment from "moment";
import { AdvancedReorderItem } from "../advanced-reorder-item";
import { MonthlyOrderModel } from "src/app/_models/monthly-order.model";
import { AdvancedReorderHelper } from "../advanced-reorder-helper";

const MONTHS = ['-01-01','-02-01','-03-01','-04-01','-05-01','-06-01','-07-01','-08-01','-09-01','-10-01','-11-01','-12-01'];

@Component({
  selector: 'advanced-reorder-slider',
  templateUrl: './advanced-reorder-slider.component.html',
  styleUrls: ['./advanced-reorder-slider.component.scss']
})

export class AdvancedReorderSliderComponent {
  @Input() helper: AdvancedReorderHelper;
  @Input() set year(year: number) {
    this.selectedYear = year;
    if (year % 4 === 0)
      this.days[1] = 29;
  }
  @Input() item: AdvancedReorderItem;
  @Output() monthSelected: EventEmitter<any> = new EventEmitter();
  @Output() sliding: EventEmitter<any> = new EventEmitter();
  selectedDays: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  selectedYear: number;
  today = moment();
  circles: HTMLElement[] = [];
  @ViewChild('start') startCircle: ElementRef<HTMLElement>;
  @ViewChild('start') endCircle: ElementRef<HTMLElement>;
  selectedCircle: HTMLElement;
  clientX: number;
  monthIndex: number;
  start: boolean;
  minIndex: number;
  maxIndex: number;
  
  constructor() { }

  get allMonths() {
    return MONTHS.map(m => `${this.selectedYear}${m}`);
  }

  getAvailablePercent(date: string, ix: number) {
    return ((this.helper.getAvailableDays(this.item, date) / this.days[ix]) * 100) || 0;
  }

  get todayPx() {
    let totalPx = 0 
    if (this.selectedYear == this.today.year()) {
      let monthIndex = this.today.month();
      totalPx = monthIndex * 70;
      totalPx += (70 / this.days[monthIndex]) * this.today.date();
    }
    return totalPx;
  }

  get daysToArrivePx() {
    return this.calculatePx(this.item.daysToArrive);
  }

  get daysOfSupplyPx() {
    return this.calculatePx(((this.item.data.totalInventory || 0) + (this.item.totalRealtime || 0)) / this.item.avgOrders);
  }

  calculatePx(days: number) {
    days = Math.floor(days);
    let lastDay = this.today.clone().add(days, 'days');
    let px: number = 0;
    if (this.today.year() <= this.selectedYear && lastDay.year() >= this.selectedYear)
    {
      let firstDay = this.today;
      if (this.today.year() < this.selectedYear) {
        firstDay = moment(`${this.selectedYear}-01-01`);
        if (lastDay.year() == this.selectedYear)
          days = lastDay.dayOfYear();
      }
      let monthIndex = firstDay.month();
      let dayPx = 70 / this.days[monthIndex];
      if (this.days[monthIndex] - (firstDay.date() - 1) < days)
      {
        px += dayPx * (this.days[monthIndex] - (firstDay.date() - 1));
        days -= this.days[monthIndex] - (firstDay.date() - 1);
        while(days > 0 && monthIndex < 11) {
          monthIndex ++;
          dayPx = 70 / this.days[monthIndex];
          if (this.days[monthIndex] < days)
            px += dayPx * this.days[monthIndex];
          else
            px += dayPx * days;
          days -= this.days[monthIndex];
        }
      }
      else
        px += dayPx * days;
    }
    else
      return 0;
    return px;
  }

  startOfSelection(date: string) {
    let prevMonth = moment(`${date}T00:00:00`);
    prevMonth.add(-1, 'month');
    return this.helper.isOrderForMonthSelected(this.item, date) &&
      !this.helper.isOrderForMonthSelected(this.item, prevMonth.format('YYYY-MM-DD'));
  }

  endOfSelection(date: string) {
    let nextMonth = moment(`${date}T00:00:00`);
    nextMonth.add(1, 'month');
    return this.helper.isOrderForMonthSelected(this.item, date) &&
      !this.helper.isOrderForMonthSelected(this.item, nextMonth.format('YYYY-MM-DD'));
  }

  circleMouseDown(e: MouseEvent, monthIndex: number, start: boolean = true) {
    this.selectedCircle = start ? this.startCircle.nativeElement : this.endCircle.nativeElement;
    this.selectedCircle.style.cursor = 'col-resize';
    this.selectedCircle.parentElement.parentElement.parentElement.style.cursor = 'col-resize';
    this.clientX = e.clientX;
    this.monthIndex = monthIndex;
    this.start = start;
    this.minIndex = monthIndex;
    this.maxIndex = monthIndex;
    if (start) {
      while(this.minIndex > 0 && !this.helper.isOrderForMonthSelected(this.item, this.allMonths[this.minIndex - 1]))
        this.minIndex -= 1;
      while(this.maxIndex < 11 && this.helper.isOrderForMonthSelected(this.item, this.allMonths[this.maxIndex + 1]))
        this.maxIndex += 1;
    }
    else {
      while(this.minIndex > 0 && this.helper.isOrderForMonthSelected(this.item, this.allMonths[this.minIndex - 1]))
        this.minIndex -= 1;
      while(this.maxIndex < 11 && !this.helper.isOrderForMonthSelected(this.item, this.allMonths[this.maxIndex + 1]))
        this.maxIndex += 1;
    }
    this.sliding.emit(this);
  }

  circleMouseMove(e: MouseEvent) {
    if (this.selectedCircle && this.selectedCircle.parentElement.parentElement.parentElement.style.cursor == 'col-resize') {
      if (this.start) {
        if (e.clientX > this.clientX + 35) {
          if (this.monthIndex < this.maxIndex) {
            this.monthIndex += 1;
            this.clientX += 70;
            this.monthSelected.emit(this.allMonths[this.monthIndex - 1]);
          }
        }
        else if (e.clientX < this.clientX - 35) {
          if (this.monthIndex > this.minIndex) {
            this.monthIndex -= 1;
            this.clientX -= 70;
            this.monthSelected.emit(this.allMonths[this.monthIndex]);
          }
        }
      }
      else {
        if (e.clientX > this.clientX + 35) {
          if (this.monthIndex < this.maxIndex) {
            this.monthIndex += 1;
            this.clientX += 70;
            this.monthSelected.emit(this.allMonths[this.monthIndex]);
          }
        }
        else if (e.clientX < this.clientX - 35) {
          if (this.monthIndex > this.minIndex) {
            this.monthIndex -= 1;
            this.clientX -= 70;
            this.monthSelected.emit(this.allMonths[this.monthIndex + 1]);
          }
        }
      }
    }
  }

  circleMouseUp(e: MouseEvent) {
    if (this.selectedCircle) {
      this.selectedCircle.style.cursor = 'pointer';
      this.selectedCircle.parentElement.parentElement.parentElement.style.cursor = 'auto';
      this.selectedCircle = null;
    }
  }

  getMonthlyOrders(year: number, date: string) {
    let mDate = new Date(`${date}T00:00:00Z`);
    return this.item.orderForYears.get(year).find(m => m.date?.getTime() == mDate.getTime());
  }
}